module.exports = __webpack_public_path__ + "static/FairWearLogo-fc8339908a6d671ef947f65ecfb1d9ae.png";